import * as React from 'react';
import { IParkCreditNotesProps } from './ParkCreditNotes.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import ParkCreditNotesForm from './ParkCreditNotes.form';
import { useCNContextSelector } from '../CreditNotes.context';
import { useFetchCreditNoteNotes } from 'api/creditNotes/creditNotes';

const ParkCreditNotes = (props: IParkCreditNotesProps): JSX.Element => {
  const { open, values, onOk: onApply, onCancel } = props;
  const noteFieldRef = React.useRef<HTMLTextAreaElement>();
  const CreditNoteId = useCNContextSelector<'CreditNote'>((state) => state.CreditNote);
  const { data: creditNoteNotes } = useFetchCreditNoteNotes(CreditNoteId);

  const initialValues = React.useMemo(
    () => ({
      ...creditNoteNotes?.Notes?.inlineObject
    }),
    [creditNoteNotes]
  );

  const valuesSchema = React.useMemo(() => (creditNoteNotes?.Notes?.schema), [creditNoteNotes]);

  const confirmationActions = (): IActionItem[] => {
    return [
      {
        title: 'Park credit note',
        iconName: 'ParkSaleIcon',
        listener: async () => {
          onApply({ ...values });
        },
        isDefault: true
      },
      {
        iconName: 'Cancel',
        title: 'Cancel',
        listener: () => {
          onCancel();
        }
      }
    ];
  };

  const focusNoteField = () => {
    noteFieldRef?.current?.focus();
  };

  React.useEffect(
    () => {
      if (open && noteFieldRef.current) {
        focusNoteField();
      }
    },
    [open, noteFieldRef.current]
  );

  return (<FormViewModal
    open={open}
    loading={false}
    title={'Park Credit Note'}
    formProps={{
      style: {
        height: '450px',
        minWidth: '500px'
      },
      formSchema: ParkCreditNotesForm,
      initialValues: {
        ...initialValues
      },
      valuesSchema: valuesSchema ? valuesSchema : {},
      fieldExtensions: {
        Note: {
          fieldRef: (Ref) => noteFieldRef.current = Ref
        }
      }
    }}
    actions={confirmationActions()}
    dialogActionsButtons={true}
    dialogActionsShadow={false}
    onActionsTabOut={focusNoteField}
    onActionShiftTabOut={focusNoteField}
  />);
};

export default ParkCreditNotes;
